<script>
	import { rtMessages, svrMessages } from '../stores/rtDataStore.js';
	import {
		Col,
		Container,
		Nav,
		NavItem,
		NavLink, Progress,
		Row,
		TabContent,
		TabPane
	} from '@sveltestrap/sveltestrap';
	import moment from 'moment';

	let processTabs = $state('1');
	const maxVisibleRows = 100;

	function addRenderKeys(messages, prefix) {
		const seenKeys = new Map();
		return messages
			.filter((m) => m && m.uuid)
			.slice(0, maxVisibleRows)
			// Realtime stores retain newest-first ordering for the compact header
			// indicator. The history dialog reads chronologically, with new items
			// appended at the bottom.
			.reverse()
			.map((message, index) => {
				const baseKey = `${prefix}:${message.uuid}`;
				const seenCount = seenKeys.get(baseKey) ?? 0;
				seenKeys.set(baseKey, seenCount + 1);
				return {
					...message,
					_renderKey: seenCount === 0 ? baseKey : `${baseKey}:${seenCount}:${index}`
				};
			});
	}

	let activeMessages = $derived(addRenderKeys($rtMessages, 'active'));
	let infoMessages = $derived(addRenderKeys($svrMessages, 'info'));

	function get_date_and_time_ago(date_str) {
		if (!date_str) return '-';
		let res_str = '';
		// add the date in the format YYYY-MM-DD HH:MM:SS
		res_str += moment(date_str).format('YYYY-MM-DD HH:mm:SS');
		res_str += ' ';
		res_str += moment(date_str).fromNow();
		return res_str;
	}

	function percentDone(value) {
		const numericValue = Number(value);
		return Number.isFinite(numericValue) ? numericValue : 0;
	}

</script>

<Container>
	<Row>
		<Col>
			<Nav class="icon-tab nav-justified nav-pills">
				<NavItem>
					<NavLink style="cursor: pointer"
									 onclick={() => (processTabs = '1')}
									 active={processTabs === '1'}>
							<span class="d-none d-sm-block">
								<i class="fas fa-tasks"></i>
								Active Processes
							</span>
						<span class="d-block d-sm-none">
							<i class="fas fa-tasks"></i>
						</span>
					</NavLink>
				</NavItem>
				<NavItem>
					<NavLink style="cursor: pointer"
									 onclick={() => (processTabs = '2')}
									 active={processTabs === '2'}>
							<span class="d-none d-sm-block">
								<i class="bx bx-message-dots"></i>
								Messages
							</span>
						<span class="d-block d-sm-none">
							<i class="bx bx-message-dots"></i>
							</span>
					</NavLink>
				</NavItem>
				<!--				<NavItem>-->
				<!--					<NavLink style="cursor: pointer"-->
				<!--									 on:click={() => (processTabs = '3')}-->
				<!--									 active={processTabs === '3'}>-->
				<!--							<span class="d-none d-sm-block">-->
				<!--								<i class="bx bx-calendar-event" /> Events-->
				<!--							</span>-->
				<!--						<span class="d-block d-sm-none">-->
				<!--								<i class="bx bx-calendar-event" />-->
				<!--							</span>-->
				<!--					</NavLink>-->
				<!--				</NavItem>-->
			</Nav>

			<TabContent activeTab={processTabs} class="p-3 text-muted">
				<TabPane tabId="1" class={processTabs === '1' ? 'active' : ''}>
					<Row>
						{#if activeMessages.length === 0}
							<Col class="col-12">
								<div class="ProgressContainer">
									<div class="pb_title text-center">
										No Active Processes, user level restricts the process you can monitor.
									</div>
								</div>
							</Col>
						{/if}
						{#each activeMessages as message (message._renderKey)}
							<Col class="col-12">
								<div class="ProgressContainer">
									<div class="pb_title">{message.title}</div>
									<div class="pb_message">{message.message}</div>
									<Row>
										<Col class="col-11">
											<Progress class="pb_progress progress-sm" striped value={percentDone(message.percent_done)} />
										</Col>
										<Col class="no-col-1" style="margin: 0px;width: 10px important;">
											<div class="pb_percent">
												{percentDone(message.percent_done).toFixed(1)}%
											</div>
										</Col>
									</Row>
								</div>
							</Col>
						{/each}
					</Row>
				</TabPane>

				<TabPane tabId="2" class={processTabs === '2' ? 'active' : ''}>
					<Row>
						{#if infoMessages.length === 0}
							<Col class="col-12">
								<div class="ProgressContainer">
									<div class="pb_title text-center">No messages have been received in this session.</div>
								</div>
							</Col>
						{/if}
						{#each infoMessages as message (message._renderKey)}
							<Col class="col-12">
								<div class="ProgressContainer"
										 class:msg_success={String(message.severity).toLowerCase() === 'success'}
										 class:msg_warning={String(message.severity).toLowerCase() === 'warn' || String(message.severity).toLowerCase() === 'warning'}
										 class:msg_error={String(message.severity).toLowerCase() === 'error' || String(message.severity).toLowerCase() === 'danger'}>
									<div class="pb_title">{message.title}</div>
									<div class="pb_message">{message.message}</div>
									<div class="pb_date">
										<!--{`${new Date(message.date_stamp).getFullYear()}-${("0" + (new Date(message.date_stamp).getMonth() + 1)).slice(-2)}-${("0" + new Date(message.date_stamp).getDate()).slice(-2)} ${("0" + new Date(message.date_stamp).getHours()).slice(-2)}:${("0" + new Date(message.date_stamp).getMinutes()).slice(-2)}`}-->
										{get_date_and_time_ago(message.date_stamp)}
									</div>
								</div>
							</Col>
						{/each}
					</Row>
				</TabPane>
				<!--				<TabPane tabId="2" class={processTabs === '3' ? 'active' : ''}>-->
				<!--					<Row>-->
				<!--						{#if $svrEvents.length === 0}-->
				<!--							<Col class="col-12">-->
				<!--								<div class="ProgressContainer">-->
				<!--									<div class="pb_title text-center">No Events have been received in this session.</div>-->
				<!--								</div>-->
				<!--							</Col>-->
				<!--						{/if}-->
				<!--						{#each $svrEvents as message (message.uuid)}-->
				<!--							<Col class="col-12">-->
				<!--								<div class="ProgressContainer">-->
				<!--									<div class="pb_title">{message.title}</div>-->
				<!--									<div class="pb_message">{message.message}</div>-->
				<!--									<div class="pb_date">{get_date_and_time_ago(message.date_stamp)}</div>-->
				<!--								</div>-->
				<!--							</Col>-->
				<!--						{/each}-->
				<!--					</Row>-->
				<!--				</TabPane>-->
			</TabContent>
		</Col>
	</Row>
</Container>

<style>
    .ProgressContainer {
        background-color: #f8f9fa;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 5px;
        margin: 5px;
    }

    .pb_title {
        font-size: 1.2em;
        font-weight: bold;
    }

    .pb_message {
        font-size: 0.9em;
        padding-bottom: 0px;
    }

    .pb_date {
        font-size: 0.7em;
        padding-bottom: 0px;
    }

    .ProgressContainer :global(.pb_progress) {
        padding-top: 4px;
    }

    .msg_success {
        background-color: #d0fbd0;
    }

    .msg_warning {
        background-color: #fff9d6;
    }

    .msg_error {
        background-color: #ffd3d6;
    }

    .pb_percent {
        font-size: 0.7em !important;
        padding: 0px !important;
        margin: 0px !important;
        text-align: right;
        margin-top: -5px !important;
        width: 20px;
    }
</style>
